module.exports = __webpack_public_path__ + "static/media/chatTabUnselected.283817f7.png";